// extracted by mini-css-extract-plugin
module.exports = {"featured-item":"featuredCategory_featured-item__1o3w9","featured-category":"featuredCategory_featured-category__3tQJR","container":"featuredCategory_container__3DYDq"};